import React from "react";
import "./Footer.css"; // Assume you have a separate CSS file for the footer
import { NavLink, Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-first-half">
          <Link to="/" className="logo-link-footer">
            <img src="/logofoot.png" alt="Logo" className="logo-foot" />
          </Link>
          <div className="footer-first-half-left">
            <div className="footer-links">
              <p>
                CONTACT: <a>IRISSIUE@siue.edu</a>
              </p>
            </div>
            <div className="social-icons-footer">
              <a href="https://twitter.com" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://facebook.com" className="social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com" className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="subscription-social-container">
          <p>© 2024 Black lit network</p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-funding">
          <p>Funded by</p>
          <div className="fund-img">
            <img
              src="/mellon.svg"
              alt="Mellon Foundation"
              title="Mellon Foundation"
              onClick={() => window.open("https://mellon.org", "_blank")}
              style={{ cursor: "pointer" }}
            />
            <img
              src="/neh.svg"
              alt="National Endowment for the Humanities"
              title="National Endowment for the Humanities"
              onClick={() => window.open("https://www.neh.gov", "_blank")}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <div className="footer-partners">
          <p>Partnered Universities</p>
          <div className="foot-partner-img">
            <img
              src="/KU.svg"
              alt="University of Kansas (KU)"
              title="University of Kansas (KU)"
              onClick={() => window.open("https://www.ku.edu", "_blank")}
              style={{ cursor: "pointer" }}
            />
            <img
              src="/UTA.svg"
              alt="University of Texas at Arlington (UTA)"
              title="University of Texas at Arlington (UTA)"
              onClick={() => window.open("https://www.uta.edu", "_blank")}
              style={{ cursor: "pointer" }}
            />
            <img
              src="/SIUE.svg"
              alt="Southern Illinois University Edwardsville (SIUE)"
              title="Southern Illinois University Edwardsville (SIUE)"
              onClick={() => window.open("https://www.siue.edu", "_blank")}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
